<section class="cf__section" aria-labelledby="cms-title">
  <div class="cf__section-head">
    <span class="cf__label" id="cms-title">Schedules</span>
  </div>

  @if (rows.length) {
    <ul class="cf__list">
      @for (row of rows; track row.id) {
        <li class="cf__item">
          <span class="cf__when">
            <span class="cf__when-main">{{ row.when }}</span>
            @if (row.sub) {
              <span class="cf__when-sub">{{ row.sub }}</span>
            }
          </span>
          <app-status text="Pending" status="pending" />
          <span class="bk-row-actions">
            <button
              type="button"
              class="bk-icon-btn"
              [attr.aria-label]="'Edit the ' + row.when + ' schedule'"
              matTooltip="Edit schedule"
              (click)="editingSchedule(row.id)"
            >
              <span class="bk-sym" aria-hidden="true">edit</span>
            </button>
            <button
              type="button"
              class="bk-icon-btn cf__danger"
              [attr.aria-label]="'Delete the ' + row.when + ' schedule'"
              matTooltip="Delete schedule"
              (click)="showDeletePrompt(row.id)"
            >
              <span class="bk-sym" aria-hidden="true">delete</span>
            </button>
          </span>
        </li>
      }
    </ul>
  } @else {
    <p class="cf__empty">No schedules yet. Add one to say when this message goes out.</p>
  }

  <!-- add another schedule -->
  <button type="button" class="bk-btn bk-btn--ghost cf__add" (click)="addSchedule()">
    <span class="bk-sym" aria-hidden="true">add</span>
    Add schedule
  </button>

  @if (editSchedule) {
    <app-update-schedule
      [openModal]="editSchedule"
      [scheduleData]="scheduleToEditData"
      (onClose)="editSchedule = false"
      (onGetSchedule)="handleGetSchedule($event)"
    ></app-update-schedule>
  }

  <!-- delete -->
  @if (deleteSchedule) {
    <app-prompt-card
      [openModal]="deleteSchedule"
      title="Delete schedule"
      buttonText="Delete schedule"
      tone="danger"
      closeText="Keep schedule"
      (onClose)="deleteSchedule = false"
      (onButtonClick)="handleDeleteSchedule()"
    >
      <p class="cf__prompt">Remove this schedule from the new message?</p>
    </app-prompt-card>
  }
</section>
